<template>
  <wz-modal
    :value="value"
    title="Cargar movimientos desde Excel"
    size="md"
    :close-on-overlay="false"
    @input="$emit('input', $event)"
  >
    <p class="text-muted mb-3">
      <template v-if="contextLabel">{{ contextLabel }}. </template>
      Descargue la plantilla, complete las filas y súbala. Si alguna fila tiene error,
      no se crea ningún movimiento del archivo.
    </p>

    <div v-if="showTemplateButton" class="mb-3">
      <wz-button variant="outline" :disabled="downloadingTemplate" @click="downloadTemplate">
        <i class="ri-download-line mr-1"></i>{{ downloadingTemplate ? 'Descargando...' : 'Descargar plantilla' }}
      </wz-button>
    </div>

    <wz-file-input
      id-file="movement-bulk-file"
      :accept-file="['.xlsx']"
      @onChange="onFileChange"
    />

    <wz-alert v-if="uploadErrors.length > 0" variant="danger" icon="ri-error-warning-line" class="mt-3">
      <strong>Se encontraron {{ uploadErrors.length }} error(es). No se creó ningún movimiento.</strong>
      <ul class="m-0 pl-3 mt-1">
        <li v-for="(e, i) in uploadErrors" :key="i">
          <template v-if="e.row">Fila {{ e.row }}: </template>{{ e.message }}
        </li>
      </ul>
    </wz-alert>

    <template #footer>
      <wz-button variant="outline" @click="close">Cancelar</wz-button>
      <wz-button variant="primary" :disabled="!uploadFile || uploading" @click="submit">
        {{ uploading ? 'Subiendo...' : 'Subir' }}
      </wz-button>
    </template>
  </wz-modal>
</template>

<script>
import { Alert } from '@wizepe/wizeui'
import { PayrollMovementService } from '@/core/services'

// Modal reutilizable de carga masiva de movimientos por Excel.
// Usa los mismos endpoints que "Descuentos y adicionales"
// (PayrollMovementService.downloadBulkTemplate / uploadBulkExcel).
export default {
  name: 'MovementBulkUploadModal',
  props: {
    value:              { type: Boolean, default: false },
    contextLabel:       { type: String,  default: '' },
    showTemplateButton: { type: Boolean, default: true },
  },
  data() {
    return {
      uploadFile: null,
      uploading: false,
      uploadErrors: [],
      downloadingTemplate: false,
    }
  },
  watch: {
    value(open) {
      // Al abrir, limpiar estado previo.
      if (open) {
        this.uploadFile = null
        this.uploadErrors = []
      }
    },
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    onFileChange(files) {
      this.uploadErrors = []
      this.uploadFile = Array.isArray(files) ? files[0] : files
    },
    async downloadTemplate() {
      try {
        this.downloadingTemplate = true
        const resp = await PayrollMovementService.downloadBulkTemplate()
        const url = URL.createObjectURL(new Blob([resp.data]))
        const a = document.createElement('a')
        a.href = url
        a.download = 'plantilla-movimientos.xlsx'
        a.click()
        URL.revokeObjectURL(url)
      } catch (e) {
        Alert.error('Error al descargar la plantilla')
      } finally {
        this.downloadingTemplate = false
      }
    },
    async submit() {
      if (!this.uploadFile) return
      try {
        this.uploading = true
        this.uploadErrors = []
        const resp = await PayrollMovementService.uploadBulkExcel(this.uploadFile)
        const created = resp && resp.created != null ? resp.created : 0
        Alert.success(`Se crearon ${created} movimiento(s) correctamente`)
        this.$emit('uploaded', created)
        this.$emit('input', false)
      } catch (error) {
        // El backend responde 400 con { errors: [{ row, message }] } cuando alguna fila falla
        if (error && Array.isArray(error.errors)) {
          this.uploadErrors = error.errors
        } else {
          Alert.error(error && error.message ? error.message : 'Error al cargar el archivo')
        }
      } finally {
        this.uploading = false
      }
    },
  },
}
</script>
